import React, { forwardRef, useEffect } from 'react';
import MaterialTable from 'material-table';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import Visibility from '@material-ui/icons/Visibility';
import { lighten } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import EditFormDialog from './EditFormDialog';
import localStorageService from 'services/LocalStorageService';
import ApiService from 'services/apiService';
import { isAccessTokenValid, refreshToken } from 'services/auth-util';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: lighten(theme.palette.background.paper, 0.1),
  },
}));

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  Visibility: forwardRef((props, ref) => <Visibility {...props} ref={ref} />),
};
export default function ProductDataTable({ coupon, getCouponList }) {
  // console.log('Data Table rendering');
  const targetName = {
    STORE: '通用 (所有人顯示/不限數量/無使用按鈕)',
    PERSON: '個人 (舊+新會員/每人1張/有使用按鈕)',
    PERSON_NEW_USER: '新會員 (只新會員/每人1張/有使用按鈕)',
    PERSON_POINT_CARD: '集點卡 (集點滿領取/集點卡可設重複集/有使用按鈕)',
    PERSON_GROUP_GIVEN: '群組用 (優惠群組連結領/可設重複領/有使用按鈕)',
  };
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [rowData, setRowData] = React.useState({});
  const [state, setState] = React.useState({
    columns: [
      { title: 'No.', render: rowData => rowData.tableData.id + 1, width: '3%' },
      { title: '優惠代碼', field: 'cpnCode' },
      { title: '優惠名稱', field: 'cpnName' },
      { title: '優惠介紹', field: 'cpnIntro' },
      { title: '優惠開始時間', field: 'cpnStartTime', type: 'date' },
      { title: '優惠結束時間', field: 'cpnStopTime', type: 'date' },
      {
        title: '優惠對象',
        field: 'cpnTarget',
        render: rowData => targetName[rowData.cpnTarget],
      },
      { title: '優惠狀態', field: 'cpnStatus', type: 'boolean' },
    ],
    data: [],
  });
  const classes = useStyles();

  const openPopup = rowData => {
    setRowData({ ...rowData });
    setIsDialogOpen(true);
  };
  // const actions = [
  //   {
  //     icon: () => <Edit />,
  //     tooltip: 'Edit the data',
  //     onClick: (event, rowData) => {
  //       openPopup(rowData);
  //     },
  //   },
  // ];
  const actionsFn = rowData => {
    const expiredTime = new Date(rowData.cpnStopTime).getTime();
    const now = new Date().getTime();
    expiredTime < now ? (rowData.expired = true) : (rowData.expired = false);
    return {
      icon: () => (expiredTime < now ? <Visibility /> : <Edit />),
      tooltip: 'Edit the data',
      onClick: (event, rowData) => {
        openPopup(rowData);
      },
    };
  };

  const removeCoupon = async cpnCode => {
    const storeCode = localStorageService.getStoreCode();
    let token = localStorageService.getToken();
    //檢查accessToken 是否過期/有效
    const validToken = await isAccessTokenValid(token);
    if (validToken.isValid === false) {
      const returnData = await refreshToken();
      token = returnData.accessToken;
    }
    await ApiService.Coupon.remove(storeCode, cpnCode, token)
      .then(response => {
        ApiService.log.add(
          storeCode,
          {
            requestUrl: `/coupon/remove/${storeCode}`,
            requestMethod: 'POST',
            responseStatus: response.status,
          },
          token,
        );
        if (response.status == 200) {
          getCouponList();
        } else {
          console.log('Coupon', 'Coupon/delete response:' + JSON.stringify(response.data));
        }
      })
      .catch(err => {
        console.log('error', err);
      });
  };
  return (
    <div>
      <MaterialTable
        className={classes.root}
        icons={tableIcons}
        title="優惠券資料列表"
        columns={state.columns}
        data={coupon}
        options={{
          actionsColumnIndex: -1,
        }}
        actions={[rowData => actionsFn(rowData)]}
        editable={{
          onRowDelete: oldData => removeCoupon(oldData.cpnCode),
        }}
      />
      <EditFormDialog
        open={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
        rowData={rowData}
        getCouponList={getCouponList}
      />
    </div>
  );
}
